<template>
  <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
    <div>
      <v-card>
        <v-card-title>
          <v-icon color="#3364FF" class="mr-8" size="48">
            mdi-chart-line
          </v-icon>
          <v-row align="start">
            <div>
              <!-- <h4>Cronograma</h4> -->
              <span class="text-h6 font-weight-black">
                <h6>{{ this.obra }} - Cronograma</h6>
              </span>
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-btn icon @click="show = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-row>
        </v-card-title>
        <v-sheet class="v-sheet--offset mx-auto" color="transparent" elevation="12" max-width="100%">
          <line-chart style="height: 400px;" :chartData="cronogramaData" :options="options"></line-chart>
        </v-sheet>
      </v-card>
      <!-- <v-card>
        <v-card-title>
          <v-icon color="red" class="mr-8" size="48">
            mdi-chart-line
          </v-icon>
          <v-row align="start">
            <div>
             
              <span class="text-h6 font-weight-black">
                <h6>{{ this.obra }} - Avance</h6>
              </span>
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-btn icon @click="show = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-row>
        </v-card-title>
        <v-sheet class="v-sheet--offset mx-auto" color="transparent" elevation="12" max-width="100%">
          <line-chart style="height: 400px;" :chartData="avanceData" :options="options"></line-chart>
        </v-sheet>
      </v-card> -->
      <v-card>
        <v-card-text>

        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>
<script>
import LineChart from "./LineChart";
import axios from "../../axios-auth";

export default {
  components: { LineChart },
  props: [
    "visible",
    "codigo",
    "labels",
    "labelsA",
    "cronogramas",
    "avancecronogramas",
    "obra",
  ],
  data() {
    return {
      cronogramaData: null,
      avanceData: null,
      varlabels: [],
      varlabelsA: [],
      varcronogramas: [],
      fechaslabel: [],
      varavance: [],
      options: null,
      optionsA: null,
    };
  },

  computed: {
    show: {
      get() {
        if (this.visible == true) { this.obtenerdatos(); }
        return this.visible;
      },
      set(value) {
        if (!value) {
          //this.$refs.form.resetValidation();
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  mounted() {
    // this.varlabels = this.labels;
    // this.varcronogramas = this.cronogramas;
    console.log("VARAVANCE", this.varavance)
    console.log("VARCRONOGR", this.varcronogramas)
    console.log("FECHAS ", this.fechaslabel)
    // this.cronogramaData = {
    //   labels: this.fechaslabel,
    //   datasets: [
    //     {
    //       data: this.varcronogramas,
    //       label: "PROYECTADO",
    //       borderWidth: 1,
    //       tension: 0.1,
    //       backgroundColor: "transparent",
    //       borderColor: "blue",
    //     },
    //     {
    //       data: this.varavance,
    //       label: "AVANCE",
    //       borderWidth: 1,
    //       tension: 0.1,
    //       backgroundColor: "transparent",
    //       borderColor: "red",
    //     },
    //   ],

    // };
    // // this.avanceData = {
    // //   labels: this.labelsA,
    // //   datasets: [
    // //     {
    // //       data: this.avancecronogramas,
    // //       label: "AVANCE",
    // //       borderWidth: 1,
    // //       tension: 0.1,
    // //       backgroundColor: "transparent",
    // //       borderColor: "red",
    // //     },
    // //   ],

    // // };
    // this.options = {
    //   scales: {
    //     yAxes: [
    //       {
    //         scaleLabel: {
    //           display: true,
    //           labelString: "Percentage",
    //         },
    //         ticks: {
    //           min: 0,
    //           max: 100,
    //           beginAtZero: true,
    //           padding: 25,
    //           callback: function (value) {
    //             return value + "%";
    //           },
    //         },
    //       },
    //     ],
    //   },
    //   responsive: true,
    //   maintainAspectRatio: false,
    // };
  },
  methods: {

    obtenerdatos() {

      // Función auxiliar para parsear fecha dd/MM/yyyy a Date
      function parseFecha(fechaStr) {
        let [dia, mes, anio] = fechaStr.split("/").map(Number);
        return new Date(anio, mes - 1, dia);
      }

      // Unificar todas las fechas en un solo eje X ordenado
      let fechasUnicas = [...new Set([...this.labels, ...this.labelsA])];
      fechasUnicas.sort((a, b) => parseFecha(a) - parseFecha(b));

      // Obtener la última fecha válida del avance (para cortar solo la línea de avance)
      let ultimaFechaAvance = this.labelsA.length > 0 ? parseFecha(this.labelsA[this.labelsA.length - 1]) : null;

      // Mapear valores del cronograma (PROYECTADO) - se extiende a TODO el período
      let cronogramaMap = {};
      this.labels.forEach((fecha, i) => cronogramaMap[fecha] = parseFloat(this.cronogramas[i]));

      this.varcronogramas = [];
      let ultimoValorCrono = 0;
      for (let fecha of fechasUnicas) {
        if (cronogramaMap[fecha] !== undefined) {
          ultimoValorCrono = cronogramaMap[fecha];
        }
        this.varcronogramas.push(ultimoValorCrono);
      }

      // Mapear valores del avance (REAL) - se corta en la última fecha registrada
      let avanceMap = {};
      this.labelsA.forEach((fecha, i) => avanceMap[fecha] = parseFloat(this.avancecronogramas[i]));

      this.varavance = [];
      let ultimoValorAvance = 0;
      for (let fecha of fechasUnicas) {
        if (ultimaFechaAvance && parseFecha(fecha) > ultimaFechaAvance) {
          this.varavance.push(null); // null = no se dibuja la línea después de la última fecha de avance
        } else {
          if (avanceMap[fecha] !== undefined) {
            ultimoValorAvance = avanceMap[fecha];
          }
          this.varavance.push(ultimoValorAvance);
        }
      }

      // Transformar fechas para el eje X (formato yyyy-MM-dd para mejor lectura)
      const fechasTransformadas = fechasUnicas.map(fecha => {
        const [dia, mes, anio] = fecha.split("/");
        return `${dia}/${mes}/${anio}`;
      });
      this.fechaslabel = fechasTransformadas;
      // console.log("AVANCE", this.avancecronogramas)
      // console.log("CRONOGR", this.cronogramas)
      this.cronogramaData = {
        labels: this.fechaslabel,
        datasets: [
          {
            data: this.varcronogramas,
            label: "PROYECTADO",
            borderWidth: 2,
            tension: 0.1,
            backgroundColor: "transparent",
            borderColor: "blue",
          },
          {
            data: this.varavance,
            label: "AVANCE",
            borderWidth: 2,
            tension: 0.1,
            backgroundColor: "transparent",
            borderColor: "red",
            spanGaps: false,
          },
        ],

      };
      // this.avanceData = {
      //   labels: this.labelsA,
      //   datasets: [
      //     {
      //       data: this.avancecronogramas,
      //       label: "AVANCE",
      //       borderWidth: 1,
      //       tension: 0.1,
      //       backgroundColor: "transparent",
      //       borderColor: "red",
      //     },
      //   ],

      // };
      this.options = {
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Percentage",
              },
              ticks: {
                min: 0,
                max: 100,
                beginAtZero: true,
                padding: 25,
                callback: function (value) {
                  return value + "%";
                },
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      };
    },
    vaciarModels() {
      //this.cronogramaData = null;
      this.varlabels = [];
      this.varcronogramas = [];
      this.varlabelsA = [];
      this.varavance = [];
      console.log("borra " + this.varcronogramas + this.varlabels);
      //this.options = null;
    },
  },
};
</script>
